<template>
  <div>
    <a-card :bordered="false">
      <div class="body_view_info">
				<div>
          <a-button
            @click="handleClickSuccessDownBtn()"
            v-if="parseInt($route.query.status)===2"
            size="large"
            type="primary"
            icon="download"
            style="margin:20px 10px;float:right;background: #6eb864; border-color: #6eb864;">下载通知书
          </a-button>
					<a-button
						@click="handleDownload"
						size="large"
						type="primary"
						icon="download"
						style="margin:20px 10px;float:right;background: #6eb864; border-color: #6eb864;">下载申请表
					</a-button>
				</div>

        <div class="bm_step_form" v-if="info">
          <div class="form_title">{{studentTypeName2}}基本信息</div>
          <div class="form_item">
            <a-row :gutter="12">
              <a-col :span="8">
                <div class="_item"><span>{{studentTypeName}}姓名：</span>{{info.student.name}}</div>
              </a-col>
              <a-col :span="8">
                <div class="_item"><span>性别：</span>{{info.student.sex === 0 ? '男' : '女'}}</div>
              </a-col>
              <a-col :span="8">
                <div class="_item"><span>民族：</span>{{info.student.nationName}}</div>
              </a-col>
              <a-col :span="8">
                <div class="_item"><span>身份证号：</span>{{info.student.idCard}}</div>
              </a-col>
              <a-col :span="8">
                <div class="_item"><span>出生日期：</span>{{info.student.birthday}}</div>
              </a-col>
              <template>
                <a-col :span="8">
                  <div class="_item"><span>申请就读年级：</span>{{info.orderGradeName}}</div>
                </a-col>
                <!-- <a-col :span="8">
                  <div class="_item"><span>原就读年级：</span>{{info.oldGradeName}}</div>
                </a-col> -->
                <a-col :span="8">
                  <div class="_item"><span>原就读学校：</span>{{info.containArea === 1 ? '区外' : '区内'}} {{info.oldSchoolName}}</div>
                </a-col>
                <a-col :span="8">
                  <div class="_item"><span>学籍：</span>{{info.hasStudentStatus === 1 ? '有' : '无'}}</div>
                </a-col>

                <a-col :span="24">
                  <div class="_item"><span>户籍地址：</span>{{info.student.nativeProvinceName}} {{ info.student.nativeCityName}} {{ info.student.nativeAreaName}}</div>
                </a-col>

              </template>
            </a-row>
          </div>

          <div class="form_title">监护人信息</div>
          <div class="form_item">
            <a-row>
              <a-col :span="8">
                <div class="_item"><span>姓名：</span>{{info.guardian.name}}</div>
              </a-col>
              <!--<a-col :span="8">-->
                <!--<div class="_item"><span>性别：</span>{{info.guardian.sex === 0 ? '男' : '女'}}</div>-->
              <!--</a-col>-->
              <!-- <a-col :span="8"> -->
                <!-- <div class="_item"><span>国籍：</span>{{info.guardian.countryName}}</div> -->
              <!-- </a-col> -->
              <a-col :span="8">
                <div class="_item"><span>联系方式：</span>{{info.guardian.mobile}}</div>
              </a-col>
              <a-col :span="8">
                <div class="_item"><span>身份证号：</span>{{info.guardian.idCard}}</div>
              </a-col>
              <a-col :span="24">
                <div class="_item"><span>证件类型：</span>{{ ['其它','四川省居住证/成都市居住证', '成都市（除龙泉驿区外）户籍居民身份证'][info.guardian.certificateType]}}</div>
              </a-col>
              <a-col :span="24">
                <div class="_item"><span>居住所在地：</span>{{info.guardian.provinceName}} {{ info.guardian.cityName}} {{ info.guardian.areaName + ' ' + info.orderStreetName + ' ' + info.guardian.villageName + ' ' + info.guardian.address}}</div>
              </a-col>
            </a-row>
          </div>

          <template v-if="studentType===2">

            <div class="form_title">关系证明</div>
            <div class="form_item">
              <a-row>
                <a-col :span="24">
                  <div class="_item"><span> </span>
                    <p style="padding-left: 50px;" v-if="info.guardian.relationType === 1">申请人及其子女同一户籍的原籍户口簿</p>
                    <p style="padding-left: 50px;" v-if="info.guardian.relationType === 2">子女父母双方的户口簿/结婚证/孩子出生医学证明或亲子鉴定 <font style="color: red">（能够证明其法定监护关系的其他有效证明）</font></p>
                    <p style="padding-left: 50px;" v-if="info.guardian.relationType === 3">申请人的户口簿/被监护人的户口簿/司法部门出具其法定监护关系的证明 <font style="color: red">（能够证明其法定监护关系的其他有效证明）</font></p>
                  </div>
                </a-col>
              </a-row>
            </div>
            <template v-if="info.student.applyType!==2">
              <div class="form_title">工作性质</div>
              <div class="form_item form_item_last">
                <a-row>
                  <a-col :span="24" v-if="info.guardian.jobType===1">
                    <div class="_item"><span style="width: 242px">劳动合同所在机构：</span>{{info.guardian.companyName}}</div>
                  </a-col>
                  <a-col :span="24">
                    <div class="_item" v-if="info.guardian.jobType===2"><span style="width: 242px">工商营业执照（统一社会信用代码）：</span>{{info.guardian.companyCode}}</div>
                  </a-col>
                  <a-col :span="24">
                    <div class="_item"><span style="width: 242px">社保证明：</span>{{info.guardian.socialSecurityProve === 1 ? '有' : '无'}}</div>
                  </a-col>
                </a-row>
              </div>

              <div class="form_title">居住满一年材料（需要在龙泉驿区合法居住连续满一年的材料）</div>
              <div class="form_item form_item_last">
                <a-row>
                  <a-col :span="24">
                    <div class="_item"><span> </span>
                      <p style="padding-left: 50px;">{{info.guardian.proofType === 2 ? '无' : '有'}}</p>
                      <!-- <p style="padding-left: 50px;" v-if="info.guardian.proofType === 1">有</p> -->
<!--                       <p style="padding-left: 50px;" v-if="info.guardian.proofType === 2">居住直系亲属自购房者：提供房产证明和亲属证明</p>
                      <p style="padding-left: 50px;" v-if="info.guardian.proofType === 3">居住房屋者：提供《房屋租赁登记备案凭证》</p>
                      <p style="padding-left: 50px;" v-if="info.guardian.proofType === 4">租住公租房和廉租房者：提供租赁合同</p>
                      <p style="padding-left: 50px;" v-if="info.guardian.proofType === 5">居住单位或集体宿舍者：提供该单位集体宿舍的房产证明及单位出具的实际居住证明</p>
 -->                    </div>
                  </a-col>
                </a-row>
              </div>
            </template>
            <template v-else>
              <div class="form_title">法定监护人（申请人）的积分信息</div>
              <div class="form_item form_item_last">
                <a-row>
                  <a-col :span="8">
                    <div class="_item">
                      <p style="padding-left: 50px;">{{info.guardian.accordType === 1 ? '不符合' : '符合'}}</p>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </template>
          </template>

          <div class="form_title">报名信息</div>
          <div class="form_item form_item_last">
            <a-row>
              <a-col :span="24">
                <div class="_item" v-if="studentType == 2"><span>审核街道：</span>{{info.orderStreetName}}</div>
                <div class="_item" v-else><span>报名幼儿园：</span>{{info.orderSchoolName}}</div>
              </a-col>
              <a-col :span="24" v-if="info.signupQuotaDomain">
                <div class="_item"><span>预约时间：</span>{{info.signupQuotaDomain.quotaDate}} {{info.signupQuotaDomain.amPmType === 1 ? '上午' : '下午'}}</div>
              </a-col>
            </a-row>
          </div>

        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css';
  import Viewer from 'v-viewer';
  import Vue from 'vue';
  import AdminCommon from './mixins/admin_common';
  Vue.use(Viewer);

  const formItemLayout = {
    labelColFirst: { span: 10 },
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
    submitWrapperCol: { span: 18, offset: 6 }
  };

  export default {
    mixins: [AdminCommon],
    components: {},
    data() {
      return {
        formItemLayout,
        info: null
      };
    },
    created() {
      window.info = this;
      this.getData();
      console.log('-> adminLevel', this.adminLevel);
    },
    methods: {
      onClickDeleteBtn() {
        let { studentSignupId } = this.$route.query;
        let self = this;
        this.$confirm({
          title: '操作提醒',
          content: '确定删除当前报名信息么？删除后将不可恢复！',
          okText: '确定',
          cancelText: '取消',
          onOk() {
            self.ajaxDeleteSignup(studentSignupId);
          },
          onCancel() {
            console.log('Cancel');
          }
        });
      },
      async ajaxDeleteSignup(studentSignupId) {
        // 删除报名记录 #李茹钰/2019-04-24#
        console.log('-> ajaxDeleteSignup', studentSignupId);
        let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_deleteSignup', {
          body: [studentSignupId]
        });
        if (data && data.code == 200 && data.data) {
          this.$message.success('删除成功！');
          setTimeout(() => {
            window.close();
          }, 2000);
        } else {
          this.$message.error(data.message || '删除失败！');
        }
      },
			async handleDownload() {
				// 导出单个人的报名信息 #李茹钰/2019-03-29#
				let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_exportSignupOss', {
					studentSignupId: this.$route.query.studentSignupId
				});

				if (data && data.code == 200 && typeof data.data === 'object') {
					console.log('[-> ViewInfo] 获取一个报名信息成功', data);
					window.open(data.data.ossFileUrl, '_blank')
				} else {
					this.$message.error('下载申请表出错！');
				}
			},
      async handleClickSuccessDownBtn(id) {
        id=id||this.$route.query.studentSignupId;
        console.log('-> handleClickSuccessDownBtn', id);
        const hide = this.$message.loading('处理中..', 0);
        // 下载报名通知单 #李茹钰/2019-04-23#
        let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_downloadSignup', {
          studentSignupId: id
        });

        try {
          if (typeof hide !== 'undefined') hide();
        } catch (e) {
          console.log('-> catch e', e);
        }
        if (data && data.code == 200 && typeof data.data === 'object') {
          console.log('[-> SchoolDetail] 下载报名通知单成功', data);
          window.open(data.data.ossFileUrl, '_blank')
        } else {
          this.$message.error('下载报名通知单出错！');
        }
      },

      async getData() {
        let { studentSignupId } = this.$route.query;
        // 根据报名预约号查询报名信息 #李茹钰/2019-03-14#
        let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_getStudentApplyVOById', { studentSignupId });
        if (data.code === 200) {
          data = data.data;
          this.info = data;
          console.log('[-> ViewInfo] 获取一个报名信息成功', data);
        } else {
          console.error('[-> ViewInfo] 获取一个报名信息失败', data);
        }
      },
      getInfoEducation(val) {
        val = Number(val);
        if (val === 1) {
          return '小学';
        } else if (val === 2) {
          return '初中';
        } else if (val === 3) {
          return '高中';
        } else if (val === 4) {
          return '专科';
        } else if (val === 5) {
          return '本科';
        } else if (val === 6) {
          return '硕士';
        } else if (val === 7) {
          return '博士';
        } else {
          return '未知';
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
  .body_view_info {
    margin 20px auto
    width 1100px
    min-height 560px
    background #fff
    border 1px solid #e5e5e5
  }
  .form_title {
    color #175375
    font-size 20px
    line-height 28px
    border-left 10px solid #35B9BF
    padding-left 20px
    font-weight 400
    margin 20px 10px 20px;
  }
  .form_item {
    border-bottom 1px solid #e5e5e5
    padding-bottom 30px
    margin-bottom 20px
    &.form_item_last {
      border 0
    }
    ._item {
      line-height 2em
      padding 4px 0
      font-size 14px
      color #333
      span {
        display inline-block
        vertical-align top
        width 118px
        text-align right
        padding-right 3px
        color #777
      }
      img._pic {
        max-width 150px
        max-height 150px
        cursor pointer
      }
    }
  }
</style>
